import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import plusIcon from '../../assets/img/icons/plus_white.svg';
import CreateProjectDropdown from '../../components/DropdownStyle/CreateProjectDropdown';
import Select from '../../components/ReactSelectDropdown';
import { filterOption } from '../../components/ReactSelectDropdown/ReactSelectDropdown';
import {
  ButtonIcon,
  ColoredButtonWithIcon,
} from '../../styledComponents/buttons';
import {
  FilterLabel,
  HeaderContainer,
  InputField,
  InputWithLabelSection,
  PageTitle,
} from '../../styledComponents/common';
import { CommonGrid } from '../../styledComponents/common';
import AddLocationModal from '../Tasks/CreateTask/AddLocationModal';
import StaticTaskLocationModal from './StaticTaskLocationModal';
import TaskLocationsTable from './TaskLocationsTable';

const TaskLocations = props => {
  const { t } = useTranslation();

  const {
    getTaskLocation,
    addTaskLocation,

    locationListIsLoading,
    addTaskLocationLoading,

    locationsList,
    createdTaskLocationInfo,

    getOfficesShortList,
    officesShortList,
    updateTaskLocation,
    updateTaskLocationLoading,
    updateTaskLocationError,
    locationTypeList,
    getLocationTypeListLoading,
    getLocationTypeList,
    archiveTaskLocation,
    isArchiving,
  } = props;

  const [taskLocations, setTaskLocations] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [addLocationModalOpen, setAddLocationModalOpen] = useState(false);
  const [seeLocationModalOpen, setSeeLocationModalOpen] = useState(false);
  const [selectedTaskLocation, setSelectedTaskLocation] = useState(null);
  const [selectedOffice, setSelectedOffice] = useState(null);
  const [officeOptions, setOfficeOptions] = useState([]);
  const [taskLocationUpdate, setTaskLocationUpdate] = useState(false);
  const [selectedLocationCategory, setSelectedLocationCategory] = useState(null);
  const [locationCategoryOptions, setLocationCategoryOptions] = useState([]);
  const [locationCategoryLoading, setLocationCategoryLoading] = useState(false);

  const getLocationCategoryList = () => {
    // Create options for active and archived
    const activeOption = {
      label: t('active'),
      value: 'active',
      is_active: true
    };

    const archivedOption = {
      label: t('archived'),
      value: 'archived',
      is_active: false
    };

    setLocationCategoryOptions([activeOption, archivedOption]);
  };

  useEffect(() => {
    setSelectedOffice({
      label: t('all_offices'),
      value: null,
    });

    // Initialize category options
    getLocationCategoryList();

    // Set default category to show active locations
    const activeCategory = {
      label: t('active'),
      value: 'active',
      is_active: true
    };
    setSelectedLocationCategory(activeCategory);

    // Call getTaskLocation with is_active=true to load active locations by default
    getTaskLocation({ is_active: true });

    getOfficesShortList();
    getLocationTypeList();
  }, []);

  useEffect(() => {
    if (officesShortList && officesShortList.length > 0) {
      let newArr = [
        {
          label: t('all_offices'),
          value: null,
        },
      ];
      officesShortList.forEach((office, i) => {
        newArr.push({
          label: office.name,
          value: office.id,
        });
      });
      setOfficeOptions(newArr);
    }
  }, [officesShortList]);

  useEffect(() => {
    if (locationsList && locationsList.length > 0) {
      setTaskLocations(locationsList);
    } else if (locationsList && locationsList.length === 0) {
      setTaskLocations([]);
    }
  }, [locationsList]);

  useEffect(() => {
    if (
      searchTerm &&
      searchTerm !== '' &&
      locationsList &&
      locationsList.length > 0
    ) {
      const originalList = JSON.parse(JSON.stringify(locationsList));
      const filteredList = [];
      originalList.forEach(e => {
        if (
          searchTerm &&
          e.name.toLowerCase().indexOf(searchTerm.toLowerCase().trim()) === -1
        ) {
          return;
        }
        filteredList.push(e);
      });
      setTaskLocations(filteredList);
    } else if (searchTerm === '') {
      setTaskLocations(locationsList);
    }
  }, [searchTerm]);

  useEffect(() => {
    if (locationTypeList && locationTypeList.length > 0) {
      getLocationCategoryList();

      // Set default category to show active locations
      const activeCategory = {
        label: t('active'),
        value: 'active',
        is_active: true
      };

      setSelectedLocationCategory(activeCategory);
    }
  }, [locationTypeList]);

  const onSearchTermChange = e => {
    const { value } = e.target;
    setSearchTerm(value);
  };

  const selectOffice = e => {
    const payload = {};
    if (e && e.value) {
      payload.office_id = e.value;
    }

    // Maintain the current category filter when changing office
    if (selectedLocationCategory && selectedLocationCategory.is_active !== undefined) {
      payload.is_active = selectedLocationCategory.is_active;
    }

    setSearchTerm('');
    getTaskLocation(payload);

    setSelectedOffice(e);
  };

  const selectLocationCategory = (category) => {
    setSelectedLocationCategory(category);

    // Create payload with explicit is_active parameter
    const payload = {
      is_active: category.is_active
    };

    // If office is selected, include it in the payload
    if (selectedOffice && selectedOffice.value) {
      payload.office_id = selectedOffice.value;
    }

    console.log('Fetching locations with payload:', payload); // Debug log

    // Fetch locations with the new filter
    getTaskLocation(payload);
  };

  const handleShowLocation = location => {
    setSelectedTaskLocation(location);

    setTimeout(() => {
      setSeeLocationModalOpen(true);
    }, 300);
  };

  const handleEditLocation = location => {
    setTaskLocationUpdate(true);
    setSelectedTaskLocation(location);
  };

  return (
    <div className="content">
      <PageTitle>{t('task_locations')}</PageTitle>
      <HeaderContainer
        columns={
          localStorage.getItem('user_role') === 'admin'
            ? '500px auto'
            : '250px auto'
        }
      >
        <CommonGrid
          columns="180px 250px 250px"
          gap="15px"
          justifyContent="flex-start"
        >
          {localStorage.getItem('user_role') === 'admin' && (
            <InputWithLabelSection>
              <FilterLabel>{t('office')}</FilterLabel>

              <Select
                isSearchable
                value={selectedOffice}
                options={officeOptions}
                placeholder="Select Office..."
                onChange={e => {
                  selectOffice(e);
                }}
                styles={CreateProjectDropdown()}
                // clearable
                filterOption={filterOption}
              />
            </InputWithLabelSection>
          )}
          <InputWithLabelSection>
            <FilterLabel>{t('search_location')}</FilterLabel>
            <InputField
              type="text"
              placeholder={t('search_by_location_name')}
              value={searchTerm}
              onChange={e => onSearchTermChange(e)}
            />
          </InputWithLabelSection>
          <InputWithLabelSection>
              <FilterLabel>{t('category')}</FilterLabel>

              <Select
                isSearchable
                value={selectedLocationCategory}
                options={locationCategoryOptions}
                placeholder="Select Category..."
                onChange={e => {
                  selectLocationCategory(e);
                }}
                styles={CreateProjectDropdown()}
                // clearable
                filterOption={filterOption}
              />
            </InputWithLabelSection>
        </CommonGrid>
        <ColoredButtonWithIcon onClick={() => setAddLocationModalOpen(true)}>
          <ButtonIcon src={plusIcon} alt="" />
          {t('add_new_location')}
        </ColoredButtonWithIcon>
      </HeaderContainer>
      <AddLocationModal
        isOpen={addLocationModalOpen}
        toggle={() => {
          setAddLocationModalOpen(false);
          setTaskLocationUpdate(false)
        }}
        addTaskLocation={addTaskLocation}
        addTaskLocationLoading={addTaskLocationLoading}
        createdTaskLocationInfo={createdTaskLocationInfo}
        getOfficesShortList={getOfficesShortList}
        officesShortList={officesShortList}
        taskLocation={selectedTaskLocation}
        taskLocationUpdate={taskLocationUpdate}
        setTaskLocationUpdate={setTaskLocationUpdate}
        updateTaskLocation={updateTaskLocation}
        updateTaskLocationLoading={updateTaskLocationLoading}
        updateTaskLocationError={updateTaskLocationError}
        getLocationTypeListLoading={getLocationTypeListLoading}
        locationTypeList={locationTypeList}
        getLocationTypeList={getLocationTypeList}
      />
      <StaticTaskLocationModal
        isOpen={seeLocationModalOpen}
        toggle={() => {
          setSeeLocationModalOpen(false);
          setSelectedTaskLocation(null);
        }}
        taskLocation={selectedTaskLocation}
      />
      <TaskLocationsTable
        locationsList={taskLocations}
        isLoading={locationListIsLoading}
        handleShowLocation={handleShowLocation}
        handleEditLocation={handleEditLocation}
        locationTypeList={locationTypeList}
        archiveTaskLocation={archiveTaskLocation}
        // selectedOrganization={selectedOrganization}
        isArchiving={isArchiving}
      />
    </div>
  );
};

export default TaskLocations;
